// EditTpInstructor's Active switch writes "-1" (active) or "0" (inactive)
// to the Active field. Missing Active/active fields count as active, since
// most existing instructor docs predate this field.
export const isInstructorInactive = (user) => {
  const activeVal = user.Active !== undefined ? user.Active : user.active;
  return activeVal !== undefined && String(activeVal) === "0";
};
